import { options } from "utils";
import { config } from "../../config";

export const createAcuerdo = async (body) => {
  const resp = await fetch(`${config.URL_API_PRIVATE}/acuerdosV2`, options("POST", body))
  const data = await resp.json()
  return data
};

export const renovarAcuerdo = async (body) => {
  const resp = await fetch(`${config.URL_API_PRIVATE}/acuerdosV2/renovar`, options("POST", body))
  const data = await resp.json()
  return data
};

export const aumentarAcuerdo = async (body) => {
  const resp = await fetch(`${config.URL_API_PRIVATE}/acuerdosV2/aumentar`, options("POST", body))
  const data = await resp.json()
  return data
};

export const clonarAcuerdo = async (body) => {
  const resp = await fetch(`${config.URL_API_PRIVATE}/acuerdosV2/clonar`, options("POST", body))
  const data = await resp.json()
  return data
};

export const getAll = async (q) => {
  const url = `${config.URL_API_PRIVATE}/acuerdos?` + q
  const response = await fetch(url, options("GET"));
  const data = await response.json();
  return data;
};

export const getAumentos = async (q) => {
  const url = `${config.URL_API_PRIVATE}/precios/aumentos?` + q
  const response = await fetch(url, options("GET"));
  const data = await response.json();
  return data;
};

export const getAumentosByAcuerdos = async (q) => {
  const url = `${config.URL_API_PRIVATE}/acuerdosV2/aumentos?` + q
  const response = await fetch(url, options("GET"));
  const data = await response.json();
  return data;
};

export const baja = async (id) => {
  const url = `${config.URL_API_PRIVATE}/acuerdos/${id}/baja`;
  const response = await fetch(url, options("PUT"));
  const data = await response.json();
  return data;
};

export const getAcuerdosProximos = async (q) => {
  const url = `${config.URL_API_PRIVATE}/acuerdosproximos?` + q
  const response = await fetch(url, options("GET"));
  const data = await response.json();
  return data;
};  